export function isMacroMatch(str: any, macro: string): boolean {
    const rgx = new RegExp(`\{\{[\s]*${macro}[\s]*\}\}`)
    return !!str && rgx.test(str.toString())
}
